import { apiMixins } from "./api";

const FILE_ENDPOINT = "item/file";

export const fileMixins = {
  mixins: [apiMixins],
  methods: {
    async renameFile(item, name) {
      await this.callAPI(`${FILE_ENDPOINT}/${item.id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      });
    },
    async moveFile(item, parentItem) {
      await this.callAPI(`${FILE_ENDPOINT}/${item.id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ parentId: parentItem.id }),
      });
    },
    async deleteFile(item) {
      await this.callAPI(`${FILE_ENDPOINT}/${item.id}`, { method: "DELETE" });
    },
    async getFileDownloadUrl(item) {
      const data = await this.callAPI('item/download-token', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: [item.id] }),
      });
      return data.urls[item.id];
    },
    async createFile({ parentItem, name, subPath, retentionSchedule, size, isSecret, contentType, tags, metadata }) {
      if (typeof subPath === 'string') {
        subPath = subPath.replace(/\\/g, '/').split('/').filter((p) => p);
      }
      const secret = isSecret ?? false;
      const data = await this.callAPI(FILE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          parentId: parentItem.id,
          name,
          subpath: subPath,
          retentionSchedule,
          size,
          isSecret: secret,
          fileMimeType: contentType,
          tags,
          metadata,
        }),
      });
      return {
        id: data.id,
        uploadUrl: data.url,
        uploadId: data.uploadId,
        sensitiveNameDetection: data.sensitiveNameDetection,
      };
    },
    async finaliseFile({ id }) {
      await this.callAPI(FILE_ENDPOINT + "/" + id + "/finalise", {
        method: "POST",
      });
    },
    async getExpiredFiles({ page = 0, pageSize = 0, sort, showLoader = true } = {}){
      return await this.callAPI(`${FILE_ENDPOINT}/expired`, {
        method: "GET",
        query: {page, pageSize,sort},
        showLoader,
      });
    },
    async getFileVersions(itemId, { page = 0, pageSize = 10, sort = "createdOn,desc", showLoader = true } = {}) {
      return await this.callAPI(`${FILE_ENDPOINT}/${itemId}/versions`, {
        method: "GET",
        query: { page, size: pageSize, sort },
        showLoader,
      });
    },
    async getFileVersionDownloadUrl(itemId, version) {
      return await this.callAPI(`${FILE_ENDPOINT}/${itemId}/versions/${version}/download`, {
        method: "GET",
        showLoader: false,
      });
    },
    async refreshIndex(itemId, { fast = false } = {}) {
      return await this.callAPI(`index/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ itemId, fast }),
        showLoader: false,
      });
    },
    async updateFile(item, {suspensionOrders, retentionSchedule, isSecret, steward, owner, tags, retainHistoric, metadata }) {
      let suspensionOrdersList = null;
      if (suspensionOrders || suspensionOrders === '') {
        suspensionOrdersList = suspensionOrders.length === 0 ? [] : suspensionOrders.split(",");
      }
      await this.callAPI(`${FILE_ENDPOINT}/${item.id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ suspensionOrders: suspensionOrdersList, retentionSchedule, isSecret, steward, owner, tags, retainHistoric, metadata }),
      });
      try {
        return await this.callAPI(`${FILE_ENDPOINT}/${item.id}`, {
          method: "GET",
          showLoader: false,
        });
      } catch (error) {
        if (error?.code === "ACCESS_DENIED") {
          return null;
        }
        throw error;
      }
    }
  },
};
